import { createFileRoute } from '@tanstack/react-router'
import { requireGuest } from '@/lib/auth-guard'
import SignInPage from '@/pages/SignIn'

export const Route = createFileRoute('/sign-in')({
  ...requireGuest(),
  component: SignInPage,
})